import { makeStyles, TableCell, TableRow } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  rowCell: {
    cursor: "pointer !important",
    background: theme.palette.primary.blue,
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
  rowCellOdd: {
    cursor: "pointer !important",
    background: "white",
    textDecoration: "none",
    "&:hover": {
      background: "rgba(0,0,0,.2) !important",
    },
  },
}));

export default function UserCell({ columns, element, index }) {
  const classes = useStyles();
  const history = useHistory();

  function changePage() {
    history.push("/usermanagement/userinfo", element);
  }

  return (
    <TableRow
      hover
      className={index % 2 ? classes.rowCell : classes.rowCellOdd}
      key={element.id}
      onClick={changePage}
      aria-label="Go to billing tier details page"
    >
      {columns.map((column, elementIndex) => (
        <TableCell align="left" key={elementIndex}>
          {element[column.propName]}
        </TableCell>
      ))}
    </TableRow>
  );
}
